export default "__VITE_ASSET__pF2XHsk0__"